
<div mat-dialog-title>Move Security into a Group<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
    <div>iRebal will review the selected security to see if it is in use elsewhere in the application before being moved.</div>
    <div>
        <div style="margin-bottom: 10px;"><strong> {{warningsData?.processArray?.length > 1 ? warningsData?.processArray?.length +" securities selected": warningsData?.processArray?.length + " security selected" }}</strong></div>
    </div>
    <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "'180px'"
            [style.minHeight]="'120px'"
            [style.maxHeight]="'270px'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions"
            [frameworkComponents] = 'frameworkComponents'
            [rowData] = 'warningsData?.processArray'
            (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    <div class="block" style="margin-top:10px;">Click "continue" to begin the review.</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button  id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
    <button  class="btn-medium-primary" (click)="onContinue()">Continue</button>
</mat-dialog-actions>
